module.exports = __webpack_public_path__ + "static/szenario1_1-77d4544d35f6c2a65eeb9a05be8b1c20.png";